'use client';
import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

interface PostItemAuthorWrapProp {
  children: React.ReactNode;
  url: string | null;
  isInsideLink?: boolean;
}

const PostItemAuthorWrap: React.FC<PostItemAuthorWrapProp> = ({
  children,
  url,
  isInsideLink = false,
}) => {
  const router = useRouter();
  const commonProps = {
    className: 'mt-2 flex items-center gap-2',
  };

  // If we're inside a link (like PostItem), use a div with onClick to avoid nested links
  if (isInsideLink && url) {
    return (
      <div
        {...commonProps}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          router.push(url);
        }}
        className={`${commonProps.className} cursor-pointer`}>
        {children}
      </div>
    );
  }

  return url ? (
    <Link href={url} {...commonProps}>
      {children}
    </Link>
  ) : (
    <div {...commonProps}>{children}</div>
  );
};

export default PostItemAuthorWrap;
